import katex from "katex";
import "katex/dist/katex.min.css";
import "./mathText.css";
import { segmentMath } from "./mathNotation.js";

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const decodeEntities = (value) =>
  String(value)
    .replace(/&nbsp;/gi, " ")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&amp;/gi, "&");

const renderPlain = (text) =>
  segmentMath(decodeEntities(text))
    .map((part) => {
      if (part.type === "text") return escapeHtml(part.value);
      try {
        const rendered = katex.renderToString(part.latex, {
          throwOnError: false,
          displayMode: Boolean(part.display),
          output: "html",
          strict: "ignore",
        });
        return rendered.replace(/\u2223/g, "|");
      } catch {
        return escapeHtml(part.latex);
      }
    })
    .join("");

/** HTML or plain text, with mathematical spans rendered and the surrounding words left as text. */
export const renderMathHtml = (input) => {
  const raw = String(input ?? "");
  if (!raw) return "";
  const tags = /<\/?[a-zA-Z][^>]*>/g;
  let html = "";
  let last = 0;
  let match;
  while ((match = tags.exec(raw))) {
    html += renderPlain(raw.slice(last, match.index));
    html += match[0];
    last = match.index + match[0].length;
  }
  html += renderPlain(raw.slice(last));
  return html;
};
